import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { useFeatureTernary } from "@viagogo/feature";
import { useContent } from "src/shared/components/content";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { Container, ListItem, ListWrapper, Message, Title } from "./styled-components";

/**
 * When a search result does not return any results, this component will notify
 * the user that there are no results and provide some tips to help
 * improve their search
 */
export const NoSearchResultsTips = ({ searchKeyword, reducedTopMargin = false }) => {
  const storePageEvent = useStorePageEvent();
  const noTitleContent = useContent("cid$#3037914#"); // "We couldn't find any results for"
  const noResultsTitleVariant = useContent("cid$#3747217#"); // "No results found"

  const noResultsTitleTernary = useFeatureTernary(FeatureSetEnum.TMSearchResultHideSearchForMessageV3);

  const noResultsTitle = noResultsTitleTernary({
    control: () => `${noTitleContent} "${searchKeyword}"`,
    variant: () => noResultsTitleVariant,
  });

  const tipsMessage = useContent("cid$#3037915#");

  // Tell us a bit more about what you are looking for
  const oneCharacterTitle = useContent("cid$#3748363#");

  const tipOne = useContent("cid$#3037916#");
  const tipTwo = useContent("cid$#3037917#");
  const tipThree = useContent("cid$#3037918#");

  const isPhone = !useMediaQuery(Breakpoint.Tablet);

  storePageEvent(PE_TYPE.LOADED, PE_KEYS.NO_SEARCH_RESULTS_TIPS, searchKeyword);

  const tipsList = [
    {
      id: 1,
      message: tipOne,
    },
    {
      id: 2,
      message: tipTwo,
    },
    {
      id: 3,
      message: tipThree,
    },
  ];

  return (
    <Container isPhone={isPhone} reducedTopMargin={reducedTopMargin}>
      {searchKeyword?.length === 1 ? <Title>{oneCharacterTitle}</Title> : <Title>{noResultsTitle}</Title>}
      <Message>{tipsMessage}</Message>

      <ListWrapper isPhone={isPhone}>
        {tipsList.map(({ id, message }) => (
          <ListItem key={id}>{message}</ListItem>
        ))}
      </ListWrapper>
    </Container>
  );
};
